import React, { useState, useEffect } from 'react';
import uuid from '../../../helpers/guid';
import { Tooltip } from 'reactstrap';
const generateRandomId = () => {
    const randomNumber = Math.random().toString(36).substring(2);
    return `span_${randomNumber}`;
};
export default function Conector({ name, node1, node2, containerRef, linha1, linha2, onClickConector }) {
    const [position, setPosition] = useState({ x1: 0, y1: 0, x2: 0, y2: 0, positionTextX: "", positionTextY: "" });
    const [tooltip, setTooltip] = useState(false);
    const [id, setId] = useState(generateRandomId());
    const toggleTooltip = () => {
        setTooltip(!tooltip)
    }

    const loadPosition = () => {
        if (node1.linha == 3) {
        }
        if (node1.ref && node2.ref && containerRef && node1.ref.current && node2.ref.current) {
            const node1Rect = node1.ref.current.getBoundingClientRect();
            const node2Rect = node2.ref.current.getBoundingClientRect();

            const childLeft1 = node1.ref.current.offsetLeft;
            const childTop1 = linha1.current.offsetTop;
            const childLeft2 = node2.ref.current.offsetLeft;
            const childTop2 = linha2.current.offsetTop;

            //Pegando as posições de x e y dos dois nós
            let x1 = childLeft1 + (node1Rect.width / 2);
            let y1 = childTop1 + (node1Rect.height / 2);
            let x2 = childLeft2 + (node2Rect.width / 2);
            let y2 = childTop2 + (node2Rect.height / 2);


            const diferenceX = Math.abs((x2 - x1) / 2);
            const diferenceY = Math.abs((y1 - y2) / 2);
            const xSum = x1 > x2 ? x2 : x1;
            const ySum = y1 > y2 ? y2 : y1;

            if (y2 < y1) {
                y2 = y2 + 40;
                x2 = x2 + 10;
            } else if (y2 > y1) {
                y2 = y2 - 30;
            }
            //Calculos para ajuste do texto em relação a linha
            const textOffset = 10;
            const angle = Math.atan2(y2 - y1, x2 - x1);
            const centerX = (x1 + x2) / 2 + Math.cos(angle) * textOffset;
            const centerY = (y1 + y2) / 2 + Math.sin(angle) * textOffset;
            const positionTextX = centerX-10;
            const positionTextY = centerY-10;

            setPosition(prevValue => { return { x1: x1, y1: y1, x2: x2, y2: y2, positionTextX: positionTextX, positionTextY: positionTextY } });
        }
    }
    useEffect(() => {
        loadPosition();
        window.addEventListener("resize", loadPosition);
    }, [node1.ref, node2.ref, containerRef]);

    if (!node1.ref || !node2.ref)
        return <></>;

    return (
        <>
            <Tooltip placement="top" isOpen={tooltip} target={id} toggle={toggleTooltip}>
                {name}
            </Tooltip>
            <span id={id} role='button' onClick={() => {
                onClickConector();
            }} className='fluxogram-conector-text rounded rounded-circle' style={{ left: position.positionTextX, top: position.positionTextY, width: "20px", height: "20px" }}> </span >

            <svg className="fluxogram-connector" style={{ left: "0", top: "0px" }}>
                <defs>
                    <marker id="arrow" markerWidth="10" markerHeight="10" refX="8" refY="3" orient="auto">
                        <path d="M0,0 L0,6 L9,3 z" fill="#666" />
                    </marker>
                </defs>
                <line x1={position.x1} y1={position.y1} x2={position.x2} y2={position.y2} stroke="#666" stroke-width="2" marker-end="url(#arrow)" />


            </svg>
        </>
    );
}